var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex py-2 px-3"},[_c('span',{staticClass:"w-100 font--bolder",style:(_vm.fontSize + _vm.getAlign + _vm.getBackground),domProps:{"innerHTML":_vm._s(_vm.templateItemData.content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }